import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createSalaryStructure = async (data) => {
  const res = await axiosInstance.post("/api/salary-structures-portal/create", data);
  return res.data;
};

export const getAllSalaryStructures = async (filters = {}) => {
  const res = await axiosInstance.get("/api/salary-structures-portal/all", { params: filters });
  return res.data;
};

export const getSalaryStructureByStaff = async (staffId) => {
  const res = await axiosInstance.get(`/api/salary-structures-portal/staff/${staffId}`);
  return res.data;
};

export const updateSalaryStructure = async (id, data) => {
  const res = await axiosInstance.put(`/api/salary-structures-portal/update/${id}`, data);
  return res.data;
};
